import React, { useEffect, useState } from 'react';
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { updateResource } from './CRUD/update';
import { jwtDecode } from "jwt-decode";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: { xs: 2, sm: 3, md: 4 }, // padding responsive
  width: { xs: '90%', sm: 400, md: 500 }, // 🔥 clave
  maxHeight: '90vh', // evita que se salga de pantalla
  overflowY: 'auto', // scroll interno
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

export default function UsersList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [editUser, setEditUser] = useState({ id: '', name: '', email: '', password: '' });
  const [selectedUser, setSelectedUser] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;
  const token = sessionStorage.getItem("access_token");
  const usuario = JSON.parse(sessionStorage.getItem("user"));
  const [showPassword, setShowPassword] = useState(false);
  const PERMISOS_CREAR_ROL = {
    1: [1,2,3,4,5,6,7],
    7: [3],
    6: [1,2,3,4,5,6,7],
    5: [],
    2: [],
    3: [],
    4: [],
  };
  const allowedRoles = PERMISOS_CREAR_ROL[usuario?.rol] || [];

  const fetchUsers = () => {
  setLoading(true);

  if (!token) {
    console.error("❌ No token found, please login");
    setLoading(false);
    return;
  }

  fetch(`${API_URL}/users`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json", 
    },
  })
    .then((res) => {
      if (!res.ok) throw new Error("❌ Error en la petición");
      return res.json();
    })
    .then((data) => {
      const filteredUsers = data.filter(user => user.id !== 1);
      setUsers(filteredUsers);
      setLoading(false);
    })
    .catch((err) => {
      console.error("❌ Error:", err);
      setLoading(false);
    });
};

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleOpen = (user) => {
    setSelectedUser(user);
    setEditUser({ id: user.id, name: user.name, email: user.email, ci: user.ci, rol: user.rol });
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setEditUser({ id: '', name: '', email: '', ci:'' });
  };
   const handleChange = (e) => {
    setEditUser({ ...editUser, [e.target.name]: e.target.value });
  };
    const handleSaveUser = async () => {
    try {
      const action = editUser.id ? 'update' : 'create';
      const url = action === 'create'
        ? `${API_URL}/users`
        : `${API_URL}/users/${editUser.id}`;

      await updateResource(url, editUser, action);
      fetchUsers();
      handleClose();
    } catch (error) {
      console.error("Fallo al guardar usuario:", error);
    }
  };
    const columns = [
            { 
              Header: "N°", 
              Cell: ({ row }) => row.index + 1 // row.index empieza en 0
            },
            { Header: "Nombre", accessor: "name" },
            { Header: "Email", accessor: "email" },
            { Header: "Rol", accessor:"rol",
              Cell: ({ value }) => {
                const roles = {
                  1: "Rector",
                  2: "Caja",
                  3: "Docente",
                  4: "Estudiante",
                  5: "Secretaria",
                  6: "Sub Dirección",
                  7: "Director Académico",
                };
                return roles[value] || "Desconocido";
              },
            },
            { Header: "Acciones",
                Cell:({ row }) =>(
                    <MDButton color="info" size="small" onClick={() => handleOpen(row.original)}>
                        Actualizar
                    </MDButton>
                ),
                width: "100px",
                align: "center",
            },
        ];

  if (loading) return <div>Cargando usuarios...</div>;

  return (
    <div>
      <MDButton sx={{ ml: 2 }} color="success" onClick={() => { setEditUser({ id: '', name: '', email: '', rol: ''}); setOpen(true); }}>
        Añadir usuario
      </MDButton>

      <DataTable
        table={{ columns, rows:users }}
        entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20] }}
        canSearch={true}  // Importante: desactiva buscador interno
        showTotalEntries={true}
        pagination={{ variant: "gradient", color: "info" }}
        isSorted={true}
        noEndBorder={false}
      />
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={ style }
        >
          <Typography variant="h6" component="h2">
            {editUser.id ? "Actualizar Usuario" : "Agregar Usuario"}
          </Typography>

          <TextField 
            label="Nombre" 
            fullWidth name="name" 
            value={editUser.name} 
            onChange={handleChange} 
            />
          <TextField 
            label="Email" 
            fullWidth name="email" 
            value={editUser.email} 
            onChange={handleChange} 
          />
          <TextField 
            label="Carnet de identidad (será su usuario)" 
            fullWidth name="ci" 
            value={editUser.ci} 
            onChange={handleChange} 
          />
          <TextField
            label="Contraseña"
            fullWidth
            name="password"
            value={editUser.password}
            onChange={handleChange}
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            select
            label="Rol"
            name="rol"
            value={editUser.rol}
            onChange={handleChange}
            fullWidth
            SelectProps={{ native: true }}
          >
              <option value=""></option>
              {allowedRoles.includes(1) && <option value="1">Rector</option>}
              {allowedRoles.includes(6) && <option value="6">Sub Dirección</option>}
              {allowedRoles.includes(7) && <option value="7">Director Académico</option>}
              {allowedRoles.includes(2) && <option value="2">Caja</option>}
              {allowedRoles.includes(3) && <option value="3">Docente</option>}
              {allowedRoles.includes(4) && <option value="4">Estudiante</option>}
              {allowedRoles.includes(5) && <option value="5">Secretaria</option>}
          </TextField>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
            <MDButton color="info" onClick={handleSaveUser}>
              {editUser.id ? "Actualizar" : "Guardar"}
            </MDButton>
            <MDButton color="secondary" onClick={handleClose}>
              Cerrar
            </MDButton>
          </Box>
        </Box>
      </Modal>


    </div>
  );
}
